import React, {useState} from 'react'
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import {useDispatch} from "react-redux";
import '../assets/css/Entrance.css'
import {toPersianNumber, toEnglishNumber, filterNonNumeric} from '../utils/numberConversion';
import {login} from "../store/userSlice";
import Loader from "../components/Loader";
import {api} from "../utils/gashtaltAPI";

function Register() {
    const persianRegex = /[\u06A9\u06AF\u06C0\u06CC\u060C\u062A\u062B\u062C\u062D\u062E\u062F\u063A\u064A\u064B\u064C\u064D\u064E\u064F\u067E\u0670\u0686\u0698\u200C\u0621-\u0629\u0630-\u0639\u0641-\u0654]/;
    const phoneRegex = /((0?9)|(\+?989))\d{2}\W?\d{3}\W?\d{4}/g;
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [nameError, setNameError] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [passwordConfirmationError, setPasswordConfirmationError] = useState(false);
    const [loading,setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleName = (e) => {
        const input = e.target.value;
        setNameError(!persianRegex.test(input));
        setName(input);
    };
    const handlePhoneNumberChange = (e) => {
        const input = e.target.value;
        setPhoneNumberError(!phoneRegex.test(toEnglishNumber(input)))
        const persianNumber = toPersianNumber(filterNonNumeric(input));
        setPhoneNumber(persianNumber);
    };
    const handlePassword = (e) => {
        const input = e.target.value;
        setPasswordError(input.length < 6);
        setPasswordConfirmationError(input !== passwordConfirmation && passwordConfirmation !== "");
        setPassword(input);
    };

    const handlePasswordConfirmation = (e) => {
        const input = e.target.value;
        setPasswordConfirmationError(password !== input);
        setPasswordConfirmation(input);
    };
    const handleLogin = async (e) => {
        e.preventDefault();
        if (name === "" || phoneNumber === "" || password === "" || passwordConfirmation === "" || nameError || phoneNumberError || passwordError || passwordConfirmationError) {
            toast.error("فرم ثبت نام را کامل کنید!", {
                position: "bottom-right"
            });
            return;
        }
        try {
            setLoading(true);
            const englishPhoneNumber = toEnglishNumber(phoneNumber);
            const response = await api.post("/api/register", {
                name: name,
                phone_number: englishPhoneNumber,
                password: password,
                password_confirmation: passwordConfirmation,
            });
            toast.success(response.data.message, {
                position: "bottom-right"
            });
            dispatch(login({
                user: response.data.data.user,
                token: response.data.data.token
            }));
        } catch (error) {
            setLoading(false);
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right"
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right"
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right"
            });
        }
    };
    if (loading) return <Loader />
    return (
        <>
            <div className="entrance-panel row justify-content-center">
                <div className="col-lg-6 form-div">
                    <h1>خوش آمدید!</h1>
                    <h2>ثبت نام</h2>
                    <form method="post" className="row" onSubmit={handleLogin}>
                        <div className="custom-input-group col-6">
                            <input type="text" className={`form-control ${nameError ? 'invalid' : ''}`}
                                   value={name}
                                   onChange={handleName}
                                   placeholder="نام و نام خانوادگی"/>
                            <p className={`form-error ${nameError ? 'visible' : 'hidden'}`}>نام و نام خانوادگی فقط می
                                تواند
                                شامل حروف فارسی باشد!</p>
                        </div>
                        <div className="custom-input-group col-6">
                            <input type="text" className={`form-control ${phoneNumberError ? 'invalid' : ''}`}
                                   value={phoneNumber}
                                   onChange={handlePhoneNumberChange}
                                   placeholder="شماره همراه"/>
                            <p className={`form-error ${phoneNumberError ? 'visible' : 'hidden'}`}>شماره همراه نادرست
                                است!</p>
                        </div>
                        <div className="custom-input-group col-6">
                            <input type="password" className="form-control"
                                   value={password}
                                   onChange={handlePassword}
                                   placeholder="رمز عبور"/>
                            <p className={`form-error ${passwordError ? 'visible' : 'hidden'}`}>رمز عبور باید حداقل 6
                                کاراکتر باشد!</p>
                        </div>
                        <div className="custom-input-group col-6">
                            <input type="password" className="form-control"
                                   value={passwordConfirmation}
                                   onChange={handlePasswordConfirmation}
                                   placeholder="تکرار رمز عبور"/>
                            <p className={`form-error ${passwordConfirmationError ? 'visible' : 'hidden'}`}>رمز عبور و
                                تکرار
                                آن یکسان نیستند!</p>
                        </div>
                        <button className="submit-button btn btn-filled col-6 d-block mx-auto" type="submit">ثبت نام
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Register;
